<template>
  <div style="background-color: #3eaf7c; height: 100vh">
    <v-toolbar dark prominent>
      <v-app-bar-nav-icon>
        <v-icon color="blue darken-2" @click="backButton">
          mdi-arrow-left
        </v-icon>
      </v-app-bar-nav-icon>

      <v-col cols="12" md="11" sm="12">
        <v-img
          src="/img/fantasy_lineups_logo.png"
          class="logo mx-auto"
          width="350"
          contain
        />
      </v-col>
    </v-toolbar>

    <div align="center" class="h_iframe">
      <v-sheet rounded elevation="2" width="420" class="ma-5 pa-3">
        <!-- <iframe
          title="Feedback Form"
          class="freshwidget-embedded-form"
          id="freshwidget-embedded-form"
          src="https://fantasylineups.freshdesk.com/widgets/feedback_widget/new?&widgetType=embedded&formTitle=Contact+Us&submitTitle=Submit+Ticket&searchArea=no"
          scrolling="no"
          height="500px"
          width="100%"
          frameborder="0"
        >
        </iframe> -->

        <p class="font-weight-bold text-h6">Contact Us</p>
        <span class="body-1 font-weight-medium"
          >If you have an questions, contact us at:
          <a href="mailto:support@fantasylineups.com"
            >support@fantasylineups.com</a
          ></span
        >
      </v-sheet>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactPage",

  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem("status") == "active") {
      next();
    } else {
      next("/login");
    }
  },

  methods: {
    // widgetCall() {
    //   window.fwSettings = {
    //     widget_id: 69000002952,
    //   };
    //   !(function() {
    //     if ('function' != typeof window.FreshworksWidget) {
    //       class n {
    //         constructor() {
    //           n.q.push(arguments);
    //         }
    //       }
    //       (n.q = []), (window.FreshworksWidget = n);
    //     }
    //   })();
    // },

    backButton() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped type="text/css" media="screen, projection">
/* @import url(https://s3.amazonaws.com/assets.freshdesk.com/widget/freshwidget.css); */
.h_iframe iframe {
  /* position: absolute;
    top: 0;
    left: 0;
    width: 100%; */
  height: 100%;
}

/* .h_iframe {
    display: flex;
  } */

/* iframe {
    justify-content: center;
  } */

body::-webkit-scrollbar {
  display: none;
}
</style>
